/** Type guard to check if a value is neither null nor undefined. */
export function isDefined<T>(arg: T | null | undefined): arg is T {
  return typeof arg !== "undefined" && arg !== null;
}
